export const productsForDropdown = `
        products {
            id
            name: short_name
        }
`;

export const FragmentProductBasicData = `
    fragment ProductBasicData on Product {
        id
        name
        short_name
    }
`;
